import * as lexActionType from '../actionsType/lexCertEnrollAvailCredit.actionType';

export const initialState = {
    response: null,
    exception: null,
    reqCreditResponse: null,
    error: null,
    cancelEnrollResponse: null,
    cancelEnrollError: null,
    enrollmentCodeResponse: null,
    enrollmentCodeError: null
};

export function lexCertEnrollAvailCreditReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.AVAILCRDIT_SUCCESS:
            return {...state, response: action.payload};
        case lexActionType.AVAILCRDIT_ERROR:
            return {...state, exception: lexActionType.AVAILCRDIT_ERROR};
        case lexActionType.REQ_CREDIT_SUCCESS:
            return {...state, reqCreditResponse: action.payload};
        case lexActionType.REQ_CREDIT_ERROR:
            return {...state, error: action.error};
        case lexActionType.CANCEL_ENROLL_SUCCESS:
            return {...state, cancelEnrollResponse: action.payload};
        case lexActionType.CANCEL_ENROLL_ERROR:
            return {...state, cancelEnrollError: action.error};
        case lexActionType.ENROLLMENT_CODE_SUCCESS:
            return {...state, enrollmentCodeResponse: action.payload};
        case lexActionType.ENROLLMENT_CODE_ERROR:
            return {...state, enrollmentCodeError: action.error};
        default:
            return state;
    }
}
